import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

// Single source of truth — shared with the checkout edge functions.
export * from "../../supabase/functions/_shared/lessons-promo.ts";
import { parsePromoUntil } from "../../supabase/functions/_shared/lessons-promo.ts";

export const LESSONS_PROMO_KEY = "lessons_promo_until";

/** Reads the admin-editable promo deadline from store_settings. */
export const useLessonsPromoUntil = () => {
  const { data } = useQuery({
    queryKey: ["store_settings", LESSONS_PROMO_KEY],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("store_settings")
        .select("value")
        .eq("key", LESSONS_PROMO_KEY)
        .maybeSingle();
      if (error) throw error;
      return parsePromoUntil(data?.value ?? null);
    },
    staleTime: 60 * 1000,
  });
  return data ?? null;
};

/** Ticking clock for the countdown — updates every minute. */
export const useMinuteTick = (enabled = true) => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    if (!enabled) return;
    const iv = setInterval(() => setNow(new Date()), 60 * 1000);
    return () => clearInterval(iv);
  }, [enabled]);
  return now;
};
